<template>
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-toolbar color="white" class="elevation-0" height="40">
        <v-speed-dial
          key="1"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip right v-if="permits['ADD_QR']">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  small
                  fab
                  v-on="on"
                  @click="addFam"
                >
                  <v-icon>add</v-icon>
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Crear un familiar</span>
            </v-tooltip>
          </template>
        </v-speed-dial>
      </v-toolbar>
      <v-container style="max-height: 75vh" class="scrollDesign">
        <v-layout row wrap>
          <v-flex xs12 class="expandableContainer">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="familiars"
              :loading="loading"
              hide-actions
              ref="table"
              item-key="id"
              no-data-text="No tiene familiares"
            >
              <template v-slot:items="props">
                <td>
                  <v-avatar :tile="tile" :size="avatarSize">
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                      v-if="
                        props.item.famFoto &&
                        props.item.famFoto !=
                          'data:image/jpeg;base64,undefined' &&
                        props.item.famFoto != 'data:image/jpeg;base64,' &&
                        props.item.famFoto != 'data:image/jpeg;base64, '
                      "
                    >
                      <img :src="props.item.famFoto" alt="avatar" />
                    </v-avatar>
                    <v-icon v-else color="blue">supervisor_account</v-icon>
                  </v-avatar>
                </td>
                <td>{{ props.item.firstName }}</td>
                <td>{{ props.item.lastName }}</td>
                <td v-if="permits['DOWNLOAD_QR']">
                  <v-btn icon @click="familiarPDF(props.item)">
                    <v-avatar :tile="tile" :size="avatarSize">
                      <v-avatar
                        :tile="tile"
                        :size="avatarSize"
                        color="grey lighten-4"
                        v-if="
                          props.item.qri &&
                          props.item.qri !=
                            'data:image/jpeg;base64,undefined' &&
                          props.item.qri != 'data:image/jpeg;base64,' &&
                          props.item.qri != 'data:image/jpeg;base64, '
                        "
                      >
                        <img :src="props.item.qri" alt="avatar" />
                      </v-avatar>
                      <v-icon v-else color="blue">not_interested</v-icon>
                    </v-avatar>
                  </v-btn>
                </td>
                <td v-else>No autorizado</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <FamiliarQR
          :class="!modals.student ? 'position-no' : ''"
          :title="modals.title"
          :parent-id="parentId"
          :value="modals.qrCreate"
          v-on:created="famCreated"
          v-on:input="closeModal"
          v-model="modals.qrCreate"
        ></FamiliarQR>

        <!--v-on:desition="desitionDelete"-->
        <loading v-model="working.wLoading" text="Trabajando"></loading>
        <success v-model="toast.success" text="Operación Exitosa"></success>
        <error v-model="toast.failed" text="Ups ocurrió un error"></error>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import { familiarMixin } from '../../../Mixins/FamiliarMixin'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import FamiliarQR from '../../Modals/FamiliarQR'
export default {
  components: {
    loading,
    success,
    error,
    FamiliarQR,
  },
  mixins: [familiarMixin],
  props: ['parentId', 'permits'],
  data: () => ({
    headers: [
      {
        text: 'Foto',
        value: 'famFoto',
        align: 'center',
        sortable: false,
      },

      {
        text: 'Nombre',
        align: 'center',
        value: 'firstName',
      },
      {
        text: 'Apellidos',
        align: 'center',
        value: 'lastName',
      },
      {
        text: 'QR',
        align: 'center',
        value: 'qrt',
      },
    ],
    selected: [],
    working: {
      wLoading: false,
    },
    familiars: [],
    loading: true,
    avatarSize: '30px',

    buttonFab: {
      fab: false,
      hidden: false,
    },
    avatarSize: '30px',
    tile: false,
    toast: {
      success: false,
      failed: false,
    },
    modals: {
      qrCreate: false,
      title: '',
      value: false,
    },
    select: {
      familiar: {},
    },
  }),
  created() {},
  mounted() {
    this.getCars()
  },
  methods: {
    getCars() {
      this.$store
        .dispatch('tutor/getParentFamiliars', this.parentId)
        .then((response) => {
          this.loading = false
          this.familiars = response.data.entity.qrs
          for (var c in this.familiars) {
            this.familiars[c].famFoto =
              'data:image/jpeg;base64,' + this.familiars[c].famFoto
            this.familiars[c].qri =
              'data:image/jpeg;base64,' + this.familiars[c].qri
          }
        })
        .catch((error) => {
          console.log(error)
          this.toast.failed = true
          this.loading = false
        })
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.familiars.slice()
    },
    addFam(event = null) {
      this.select.familiar = null
      this.modals.title = 'Crear familiar'
      this.modals.qrCreate = true
    },
    famCreated(e) {
      this.toast.success = true
      e.famFoto = 'data:image/jpeg;base64,' + e.famFoto
      e.qri = 'data:image/jpeg;base64,' + e.qri
      this.familiars.unshift(e)
    },
    closeModal(event) {
      this.modals.qrCreate = false
    },

    familiarPDF(fam) {
      var obj = {}
      obj.firstName = fam.firstName
      obj.lastName = fam.lastName
      obj.qri = fam.qri.replace('data:image/jpeg;base64,', '')

      this.createQRPDF(obj)
    },
  },
}
</script>
<style>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
td,
th {
  text-align: center !important;
}
</style>
